import { render, staticRenderFns } from "./LessonProcessSetting.vue?vue&type=template&id=586c36ab&scoped=true&lang=pug&"
import script from "./LessonProcessSetting.vue?vue&type=script&lang=ts&"
export * from "./LessonProcessSetting.vue?vue&type=script&lang=ts&"
import style0 from "./LessonProcessSetting.vue?vue&type=style&index=0&id=586c36ab&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586c36ab",
  null
  
)

export default component.exports